import { type ReactElement } from 'react';

import { alpha, Button, type ButtonProps, styled } from '@mui/material';

type OmittedProps = 'variant';

export type DeleteButtonProps = Omit<ButtonProps, OmittedProps>;

const DeleteButtonBootsrap = styled(Button)<DeleteButtonProps>(({ theme }) => {
  return {
    '&.MuiButton-contained': {
      fontWeight: 700,
      textTransform: 'none',
      borderRadius: 8,
      backgroundColor: theme.palette.red.main,
      color: theme.palette.white.main,
      '&:hover': {
        backgroundColor: theme.palette.red300.main,
      },
      '&.Mui-disabled': {
        border: `1px solid ${theme.palette.gray500.main}`,
        color: theme.palette.gray300.main,
        backgroundColor: theme.palette.gray200.main,
      },
      '&:focus': {
        // outlineOffset: 2,
        // outline: `2px solid ${theme.palette.horizonBlue1.main}`,
        outline: 0,
      },
    },
  };
});

export const DeleteButton = (props: DeleteButtonProps): ReactElement => (
  <DeleteButtonBootsrap {...props} variant="contained" />
);
